import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ChatFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M19 4.91C17.13 3.03 14.64 2 11.99 2C6.53 2 2.08 6.45 2.08 11.91C2.08 13.66 2.54 15.36 3.4 16.86L2 22L7.25 20.62C8.7 21.41 10.33 21.83 11.99 21.83C17.45 21.83 21.9 17.38 21.9 11.92C21.9 9.27 20.87 6.78 19 4.91Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ChatFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ChatFilledIcon;
